import React from 'react'
import { DateTimeRangePicker, Flex, Label } from '@leverege/ui-elements'
import { useValueChange } from '@leverege/ui-hooks'
import { DataViewerCardModel, HistoryViewModel } from '@leverege/molten/data-viewers'

export default {
  id : 'events.DateRange',
  layout : {
    sort : 'z'
  },
  matches : {
    client : 'EventsView',
    use : 'filterBar'
  },
  handles : ( context ) => {
    const { clientProps } = context
    const { dataViewerCardModel } = clientProps

    const needsDate = dataViewerCardModel && DataViewerCardModel.getNeedsDate( dataViewerCardModel )

    return !needsDate
  },
  customComponent : DateRangeSelector
}

function DateRangeSelector( { context } ) {
  const { clientProps } = context
  const { settings : model, settingsData : eventData, onSettingsChange : onChange } = clientProps

  const range = HistoryViewModel.getRange( model )

  const timeValue = getTimeValue( range )

  const onChangeModel = useValueChange( HistoryViewModel, {
    ...clientProps,
    value : model,
    eventData,
    onChange
  } )

  return (
    <Flex variant="rowMCenter">
      <Label variant="dateRange">Time Range:</Label>
      <DateTimeRangePicker
        variant="history"
        toggleVariant="dateRange"
        inputVariant="dateRange"
        value={timeValue}
        eventData="setRange"
        onChange={onChangeModel} />
    </Flex>
  )
}

function getTimeValue( range ) {

  if ( typeof range === 'string' ) {
    return range
  }

  const ret = { ...range }
  if ( ret.start != null && !( ret.start instanceof Date ) ) {
    ret.start = new Date( ret.start )
  }

  if ( ret.end != null && !( ret.end instanceof Date ) ) {
    ret.end = new Date( ret.end )
  }

  return ret
}
